<template>
  <Slideover :visible="visible">
    <div>
      <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
        <div class="flex items-start justify-between space-x-3">
          <h2 class="text-lg leading-7 font-medium">
            {{ title }}
          </h2>
          <div class="h-7 flex items-center">
            <button
              type="button"
              aria-label="Close panel"
              @click="closeSlideover"
              class="text-green-300 hover:text-white transition ease-in-out duration-150"
            >
              <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
            </button>
          </div>
        </div>
      </header>

      <!-- Main -->
      <div class="py-4 px-4 space-y-2">
        <div class="py-2">
          <label
            class="font-bold block text-sm font-medium leading-5 text-gray-700"
          >
            Site
          </label>
          <div class="text-sm">{{ discount.store_front }}</div>
        </div>
        <div class="py-2">
          <label
            class="font-bold block text-sm font-medium leading-5 text-gray-700"
          >
            Code
          </label>
          <div class="text-sm">{{ discount.shopify_discount_code }}</div>
        </div>
        <div class="py-2">
          <label
            class="font-bold block text-sm font-medium leading-5 text-gray-700"
          >
            Amount
          </label>
          <div class="text-sm">{{ discount.total_amount | currency }}</div>
        </div>
      </div>
      <HttpError :error="error" dismissable />
      <div class="flex-shrink-0 px-4 py-4 space-x-4 flex justify-end">
        <span class="inline-flex rounded-md shadow-sm">
          <Button @click-handler="closeSlideover" class="btn-white">
            Cancel
          </Button>
        </span>
        <span class="inline-flex rounded-md shadow-sm">
          <Button :disabled="processing" @click-handler="deactivate">
            <span>Submit</span>
            <LoadingSpinner v-if="processing" class="text-white" />
          </Button>
        </span>
      </div>
    </div>
  </Slideover>
</template>
<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import Button from "@/components/elements/Button.vue";
import Slideover from "@/components/layout/Slideover.vue";
import moneyFormatter from "@/mixins/moneyFormatter";

const ShopifyDiscount = ApiFactory.get("shopify-disocunts");

export default {
  name: "DeactivateDiscount",
  components: {
    Button,
    Slideover,
  },
  props: {
    title: {
      type: String,
      default: "Title",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    discount: {
      type: Object,
    },
  },
  data() {
    return {
      processing: false,
      error: null,
    };
  },
  filters: {
    currency: moneyFormatter.format,
  },
  mixins: [moneyFormatter],
  computed: {},
  watch: {},
  methods: {
    deactivate() {
      this.error = null;
      this.processing = true;
      ShopifyDiscount.update(this.discount.id, { active: false })
        .then(() => {
          this.$emit("update-discounts");
          this.$emit("toggle-slideover");
        })
        .catch((e) => {
          this.error = e;
        })
        .finally(() => {
          this.processing = false;
        });
    },
    closeSlideover() {
      this.$emit("toggle-slideover");
    },
  },
};
</script>
